/**
 * Hook for fetching affaire payment summary
 * Used by CaseSidebar to display color-coded payment status
 */

import { useQuery } from '@tanstack/react-query';
import { getAffairePaymentSummary, type PaymentSummaryResponse } from '../../facturation/api/facturation.api';

/**
 * Fetch payment summary for an affaire
 * Returns billing totals, invoice status, and payment status with color coding
 *
 * @param affaireId - The affaire ID (number)
 * @returns React Query result with payment summary data
 */
export const useAffairePaymentSummary = (affaireId: number | null) => {
  return useQuery<PaymentSummaryResponse>({
    queryKey: ['affaire-payment-summary', affaireId],
    queryFn: () => getAffairePaymentSummary(String(affaireId)),
    enabled: !!affaireId,
    staleTime: 30000, // 30 seconds
    refetchOnWindowFocus: false,
  });
};

export type { PaymentSummaryResponse };
